import { contactRemover } from '@/data/Content/_PersonContactFetcher';
import { usePersonInfo } from '@/data/Content/PersonInfo';
import { useSettings } from '@/data/Settings';
import { useEffect } from 'react';

export const useRemoveGuestAddresses = () => {
	const { personInfo, addresses, setPrimaryAddress, setDisplayAddresses } = usePersonInfo();
	const { settings } = useSettings();

	useEffect(() => {
		if (
			!personInfo?.email1 ||
			!addresses ||
			addresses.length === 0 ||
			personInfo?.profileType !== 'Consumer'
		)
			return;
		setDisplayAddresses(addresses);
		const removeGuestAddresses = async () => {
			const { email1 } = personInfo ?? {};
			const addressesToRemove = (addresses ?? [])
				.filter(
					(address) =>
						address?.email1 &&
						address?.nickName &&
						address.email1 !== email1 &&
						address.nickName === address.email1
				)
				.map((addr) => addr.nickName);
			if (addressesToRemove && addressesToRemove.length > 0) {
				await Promise.all(
					addressesToRemove.map(
						(nickName) => nickName && contactRemover(true)(settings.storeId, nickName, {}, {})
					)
				);
				setPrimaryAddress(email1);
			}
		};
		removeGuestAddresses();
	}, [addresses, personInfo?.email1]);
};
